interface OwnProps {
	height?: number;
	width?: number;
	color?: string;
}
export const ArrowIcon = ({ height, width, color }: OwnProps) => (
	<svg width={width ? width : 25} height={height ? height : 25} viewBox="0 0 25 25" fill="none">
		<path
			d="M4.5 12.5H20.5M20.5 12.5L14.5 6.5M20.5 12.5L14.5 18.5"
			stroke={color ? color : "#FFFFFF"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const EditIcon = () => (
	<svg width="22" height="22" viewBox="0 0 24 24" fill="none">
		<path
			d="M12 20H21M3 20H4.67454C5.16372 20 5.40832 20 5.63849 19.9447C5.84256 19.8957 6.03765 19.8149 6.2166 19.7053C6.41843 19.5816 6.59138 19.4086 6.93729 19.0627L19.5 6.49998C20.3285 5.67156 20.3285 4.32841 19.5 3.49998C18.6716 2.67156 17.3285 2.67156 16.5 3.49998L3.93726 16.0627C3.59136 16.4086 3.4184 16.5816 3.29472 16.7834C3.18506 16.9624 3.10425 17.1574 3.05526 17.3615C3 17.5917 3 17.8363 3 18.3255V20Z"
			stroke="#4BA540"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
